const price = `
    price_range {
        minimum_price {
            regular_price {
                value
                currency
            }
            final_price {
                value
                currency
            }
            discount {
                percent_off
                amount_off
            }
        }
        promotion_price {
            discount {
                percent_off
            }
        }
    }
`;

const variants = `
    variants {
        attributes {
            label
            value_index
        }
        product {
            name
            sku
            stock_status
            default_product_size
            display_weight
            weight
            image {
                url
                label
            }
            ${price}
        }
    }     
`;

const wisList = `
    {
        id
        name
        visibility
        items_count
        updated_at
        sharing_code
        items_v2(pageSize: 9999) {
            items {
                id
                quantity
                product {
                    name
                    sku
                    url_key
                    stock_status
                    type_id
                    image {
                        url
                        label
                    }
                    ${price}
                    ... on ConfigurableProduct {
                        ${variants}
                    }
                }
            }
        }
    }
`;

const wishLists = `{
    customer {
        wishlists ${wisList}
    }
}`;

const createWishList = `
    mutation CreateWishlist($input: CreateWishlistInput!) {
        createWishlist(input: $input) {
            wishlist ${wisList}
        }
    }
`;

const deleteWishList = `
    mutation DeleteWishlist($wishlistId: ID!) {
        deleteWishlist(wishlistId: $wishlistId) {
            wishlists ${wisList}
        }
    }
`;

const updateWishList = `
    mutation UpdateWishlist($wishlistId: ID!, $name: String, $visibility: WishlistVisibilityEnum) {
        updateWishlist(wishlistId: $wishlistId, name: $name, visibility: $visibility) {
            name
            uid
            visibility
        }
    }
`;

const addProductsToWishList = `
    mutation AddProductsToWishlist($wishlistId: ID!, $wishlistItems: [WishlistItemInput!]!) {
        addProductsToWishlist(wishlistId: $wishlistId, wishlistItems: $wishlistItems) {
            wishlist ${wisList}
        }
    }
`;

const removeProductsFromWishList = `
    mutation RemoveProductsFromWishlist($wishlistId: ID! $wishlistItemsIds: [ID!]!) {
        removeProductsFromWishlist(wishlistId: $wishlistId, wishlistItemsIds: $wishlistItemsIds) {
            wishlist ${wisList}
        }
    }
`;

const moveProductsBetweenWishLists = `
    mutation MoveProductsBetweenWishlists($sourceWishlistUid: ID!, $destinationWishlistUid: ID!, $wishlistItems: [WishlistItemMoveInput!]!) {
        moveProductsBetweenWishlists(sourceWishlistUid: $sourceWishlistUid, destinationWishlistUid: $destinationWishlistUid, wishlistItems: $wishlistItems) {
            source_wishlist ${wisList}
            destination_wishlist ${wisList}
        }
    }
`;

const copyProductsBetweenWishLists = `
    mutation CopyProductsBetweenWishlists($sourceWishlistUid: ID!, $destinationWishlistUid: ID!, $wishlistItems: [WishlistItemCopyInput!]!) {
        copyProductsBetweenWishlists(sourceWishlistUid: $sourceWishlistUid, destinationWishlistUid: $destinationWishlistUid, wishlistItems: $wishlistItems) {
            destination_wishlist ${wisList}
        }
    }
`;

export default {
    wishLists,
    createWishList,
    deleteWishList,
    updateWishList,
    addProductsToWishList,
    removeProductsFromWishList,
    moveProductsBetweenWishLists,
    copyProductsBetweenWishLists,
};
